/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */ 
export const StyledAlertTypes = {
    primary: "primary" as const,
    warning: "warning" as const
};

export type StyledAlertTypes = typeof StyledAlertTypes[keyof typeof StyledAlertTypes];
